<template>
  <aside 
    class="w-64 bg-white dark:bg-gray-800 text-[#035a76] dark:text-gray-200 shadow-lg flex-shrink-0 fixed h-full z-10 transition-all duration-300"
    :class="{'ml-0': isOpen, '-ml-64': !isOpen}"
  >
    <div class="p-6 flex items-center space-x-2 border-b border-gray-200 dark:border-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
      <span class="text-2xl font-bold">School HR</span>
    </div>
<nav class="mt-6 overflow-y-auto h-[calc(100%-80px)] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 dark:scrollbar-thumb-gray-600 dark:scrollbar-track-gray-800">
        <ul class="space-y-1 px-2 pb-6">
        <!-- Dashboard -->
        <li>
          <RouterLink 
            :to="{ name: 'hrdashboard'}" 
            class="flex items-center px-6 py-3 text- hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Dashboard
          </RouterLink>
        </li>

       

        <li>
          <RouterLink 
            to="/users" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20h6m-3-4a4 4 0 100-8 4 4 0 000 8zm-6-4a6 6 0 0112 0v5H3v-5z" />
            </svg>
            {{ $t('sidebar.users') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink 
            to="/audit-logs" 
            class="flex items-center px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
            active-class="router-link-active"
          >
<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2" />
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
        d="M9 17h6M9 13h6" />
</svg>
            {{ $t('audits') }}
          </RouterLink>
        </li>

        
        <!-- Staff Management -->
      
        <li>
  <!-- Master Data Button -->
  <button
    @click="toggleMasterData"
    class="flex items-center justify-between w-full px-6 py-3 hover:bg-[#74bd54] hover:text-white transition-colors duration-200 dark:hover:bg-gray-700"
  >
    <div class="flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16" />
      </svg>
       {{$t('sidebar.masterData')}}
    </div>

    <!-- Arrow -->
    <svg
      :class="{ 'rotate-180': showMasterData }"
      class="h-4 w-4 transition-transform duration-200"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Submenu -->
  <ul v-show="showMasterData" class="bg-gray-100 dark:bg-gray-800">

    <li>
      <RouterLink to="/departments"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.departments')}}
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/positions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.positions')}}
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/contract-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.contractTypes')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/process-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.processTypes')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/allowances"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.allowances')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/contract-status"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.contractStatus')}}
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/agency"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.agencies')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/leave-types"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.leaveTypes')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/interview-questions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.interviewQuestions')}}
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/interview-evaluation"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.interviewEvaluation')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/employee-actions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.employeeActions')}}
      </RouterLink>
    </li>

    <li>
      <RouterLink to="/attendance-status"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.attendanceStatus')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/working-hours"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.workingHours')}}
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/sections"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Sections
      </RouterLink>
    </li>
    <li>
      <RouterLink to="/classes"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Classes
      </RouterLink>
    </li>
        <li>
      <RouterLink to="/subjects"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.subjects')}}
      </RouterLink>
    </li>
            <li>
      <RouterLink to="/modules"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Modules
      </RouterLink>
    </li>
            <li>
      <RouterLink to="/permissions"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        Permissions
      </RouterLink>
      
    </li>
      <li>
      <RouterLink to="/user-permission"
        class="block pl-14 pr-6 py-2 hover:bg-[#74bd54] hover:text-white">
        {{$t('sidebar.userPermission')}}
      </RouterLink>
      
    </li>  
  </ul>
</li>
      </ul>
    </nav>
  </aside>
</template>

<script setup>
import { ref } from 'vue';
import { usePermissions } from '@/composables/usePermissions'

defineProps({
  isOpen: {
    type: Boolean,
    required: true
  }
});
const showMasterData = ref(false)

const toggleMasterData = () => {
  showMasterData.value = !showMasterData.value
}

const { canAccessModule } = usePermissions()
</script>

<style scoped>
.router-link-active {
  background-color: #74bd54;
  color: white !important;
  font-weight: 600;
}
</style>